/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { TextField } from '@insticator/insticator-ui'
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import { ReactComponent as NoneIcon } from 'assets/icons/none.svg'
import Space from 'material/space/space';
import { ConfigToggle, SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './headertitle_styles'
import PreviewConfig from 'material/previewconfig/previewconfig'
import { useDispatch } from 'react-redux';

import { ReactComponent as SmileBlackIcon } from 'assets/icons/article-sentiment/smile-black.svg'
import { ReactComponent as SmileWhiteIcon } from 'assets/icons/article-sentiment/smile-white.svg'
import { ReactComponent as ThoughtBalloonBlackIcon } from 'assets/icons/article-sentiment/thought-balloon-black.svg'
import { ReactComponent as ThoughtBalloonWhiteIcon } from 'assets/icons/article-sentiment/thought-balloon-white.svg'
import { ReactComponent as ThinkingFaceWhiteIcon } from 'assets/icons/article-sentiment/thinking-face-white.svg'
import { setArticleSentimentConfigSectionValid } from 'state/slices/articlesentimentv2';

const icons = {
  SMILE_BLACK: <SmileBlackIcon />,
  SMILE_WHITE: <SmileWhiteIcon />,
  THOUGHT_BALLOON_BLACK: <ThoughtBalloonBlackIcon />,
  THOUGHT_BALLOON_WHITE: <ThoughtBalloonWhiteIcon />,
  THINKING_FACE_WHITE: <ThinkingFaceWhiteIcon />,
  NONE: <NoneIcon />
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : HEADER TITLE ~~~~~~~~~~ ========== */
const HeaderTitle = injectSheet(styles)((props) => {

  const dispatch = useDispatch()

  const { enableHeader, headerIcon, headline, enableHeaderBorder, onChange } = props

  const handleIconChange = icon =>  onChange({'headerIcon': icon})

  useEffect(() => {
    if(headline) dispatch(setArticleSentimentConfigSectionValid({configName: 'generalConfig', isValid: true}))
    else dispatch(setArticleSentimentConfigSectionValid({configName: 'generalConfig', isValid: false}))
  }, [dispatch, headline])

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`headertitle ${props.classes.headertitle}`} 
      title={'Header title'} 
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <ConfigToggle 
            title={'Enable header'}
            description={'Customize the title with your own phrase and imagery.'}
            checked={enableHeader}
            indented={false}
            onChange={val => onChange({'enableHeader': !enableHeader})}
          >
          <Space direction={'column'} gap={16}>
            <TextField 
              type={`text`} 
              name={`headline`} 
              icon={<ComposeIcon />}
              value={headline} 
              handleChange={e => onChange({'headline': e.target.value})}
              placeholder={``} 
              required
              valid={!!headline}
              maxLength={128}
            />
            <p>Choose an icon style </p>
            <Space klass={'headericons'}>
              {Object.keys(icons).map(key => (
                  <div className={`icon selected-${headerIcon === key}`} onClick={() => handleIconChange(key)}>
                   {icons[key]}
                 </div>
              ))}
            </Space>
            <ConfigToggle 
              title={'Enable header border'}
              checked={enableHeaderBorder}
              onChange={val => onChange({'enableHeaderBorder': !enableHeaderBorder})}
              gap={16}
            />
          </Space>
          </ConfigToggle>
          <PreviewConfig>
            <Space>
              {headerIcon !== 'NONE' && icons[headerIcon]}
              <h3>{headline}</h3>
            </Space>
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HeaderTitle;